/* These Bricks — samodejno menjavanje slik na produktni strani */
(function () {
  var DELAY = 4000;
  var RESUME_AFTER = 8000;

  function init() {
    var gallery = document.querySelector('main[data-template^="product"] media-gallery');
    if (!gallery) return;
    var slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow) return;
    var slides = slideshow.querySelectorAll('slideshow-slide');
    if (slides.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var paused = false;
    var resumeTimer = null;
    var inView = true;

    function pauseFor(ms) {
      paused = true;
      clearTimeout(resumeTimer);
      if (ms) resumeTimer = setTimeout(function () { paused = false; }, ms);
    }

    function next() {
      if (typeof slideshow.next === 'function') {
        slideshow.next();
        return;
      }
      var btn = slideshow.querySelector('slideshow-arrows button:last-of-type, [ref="next"]');
      if (btn) btn.click();
    }

    gallery.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pauseFor(0); });
    gallery.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { paused = false; } });
    gallery.addEventListener('touchstart', function () { pauseFor(RESUME_AFTER); }, { passive: true });
    gallery.addEventListener('click', function () { pauseFor(RESUME_AFTER); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }, { threshold: 0.4 }).observe(slideshow);
    }

    setInterval(function () {
      if (paused || !inView || document.hidden) return;
      if (document.querySelector('.dialog-zoomed-gallery__dialog[open]')) return;
      next();
    }, DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 300); });
  } else {
    setTimeout(init, 300);
  }
})();

/* V1.9 — lepljivi gumb "Dodaj v košarico": viden ves čas med pomikanjem */
(function () {
  function init() {
    var host = document.querySelector('sticky-add-to-cart');
    if (!host) return;
    var root = document.documentElement;
    function onScroll() { root.classList.toggle('tb-sticky-on', window.scrollY > 160); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Kompaktna cena pod naslovom (mobilno)
    var info = host.querySelector('.sticky-add-to-cart__info');
    var src = host.querySelector('.sticky-add-to-cart__price');
    if (!info || !src) return;
    var box = document.createElement('div');
    box.className = 'tb-sticky-price';
    info.appendChild(box);
    function sync() {
      var p = src.querySelector('.price'), c = src.querySelector('.compare-at-price');
      box.classList.toggle('is-sale', !!c);
      box.innerHTML = (p ? '<b>' + p.textContent.trim() + '</b>' : '') + (c ? '<s>' + c.textContent.trim() + '</s>' : '');
    }
    sync();
    new MutationObserver(sync).observe(src, { childList: true, subtree: true, characterData: true });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
